import { WS_DOMAIN } from '../constants';

export const IDENTITY_ICON_TYPES = {
  COPILOT: 'COPILOT',
  HUMAN: 'HUMAN',
  BOOTUP_PAGE_BOT: 'BOOTUP_PAGE_BOT',
};

export const PREDEFINED_TEMPLATE_TYPES = {
  CREATE_COUPON: 'CREATE_COUPON',
  CREATE_PROMOTION: 'CREATE_PROMOTION',
  MILESTORE_PERIOD_AGNOSTIC: 'MILESTORE_PERIOD_AGNOSTIC',
};

export const MESSAGE_GET_ANSWER = 'MESSAGE_GET_ANSWER';
export const MESSAGE_CHUNK = 'MESSAGE_CHUNK';
export const MESSAGE_METADATA = 'MESSAGE_METADATA';
export const MESSAGE_COMPLETE = 'MESSAGE_COMPLETE';
export const MESSAGE_LIKE = 'MESSAGE_LIKE';
export const MESSAGE_DISLIKE = 'MESSAGE_DISLIKE';

export const SERVER_URL = `${WS_DOMAIN}/arya/api/v1/ask-aira-service/copilot/chat`;

export const DOCS_URL = 'https://docs.capillarytech.com/';
export const MOCK_WS_URL = 'ws://cap-doc-mock-websocket';

export const MESSAGE_TYPE_TEXT = 'TEXT';
export const MESSAGE_TYPE_CLEAR = 'CLEAR';
export const MESSAGE_TYPE_INFERENCE = 'INFERENCE';
export const MESSAGE_TYPE_COPY = 'COPY';
export const MESSAGE_TYPE_STATUS = 'STATUS';
export const MESSAGE_TYPE_APPROVE = 'APPROVE';

export const MESSAGE_TYPES = {
  COPILOT: 'COPILOT',
  HUMAN: 'HUMAN',
};
